import * as ErrorHandler from 'common/ErrorHandler';
import { Api, SecureApi } from 'common/http';
import { UrlParams } from 'common/url-params';
import { CONFIG } from 'constants/config';

import type {
  IListingRequestParams,
  IPromotionResponse,
  IPromotionsByOrderResponse,
  IPromotionsResponse
} from 'types';

// Promotions

export async function getPromotions() {
  try {
    const { data } = await Api.get<IPromotionsResponse>('/campaigns/active');
    return data;
  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting promotions data');
  }
}

// Promotion

export async function getPromotion(params: IListingRequestParams) {
  try {
    const {
      category,
      page = 1,
      itemsPerPage = CONFIG.PAGINATION.DEFAULT_SIZE,
      orderBy,
      filters,
      identifier
    } = params || {};

    const orderByQs = UrlParams.getOrderByQueryString(orderBy);
    const filtersQs = UrlParams.getFiltersQueryString(filters);

    const endpoint = `/campaigns/${identifier}?category=${category}&page=${page}&itemsPerPage=${itemsPerPage}${orderByQs}${filtersQs}`;

    const { data } = await Api.get<IPromotionResponse>(endpoint);
    return data;

  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting promotion details data', { slug: params?.identifier, category: params?.category });
  }
}

// Promotions By Order
export async function getPromotionsByOrder(tokenValue: string) {
  try {
    const { data } = await SecureApi.get<IPromotionsByOrderResponse>(`/orders/${tokenValue}/campaigns/incomplete`);
    return data;
  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting promotions for order', { err, tokenValue });
  }
}
